import { z } from 'zod';
import { TimestampSchema } from './common.js';
/**
 * The tenant's QuickBooks Online connection (specification 8.14): one Intuit-authorized
 * company per organization. Credentials never appear here; the connection reports its state,
 * the company it points at, and the last sync outcome.
 */
export const QuickBooksEnvironmentSchema = z.enum(['sandbox', 'production']);
export const QuickBooksConnectionSchema = z.strictObject({
    /** `unavailable` when the deployment has no Intuit app configured. */
    status: z.enum(['unavailable', 'disconnected', 'connected', 'error']),
    environment: QuickBooksEnvironmentSchema.nullable(),
    /** Intuit's identifier for the connected company (the realm id). */
    realmId: z.string().nullable(),
    companyName: z.string().nullable(),
    connectedAt: TimestampSchema.nullable(),
    lastSyncedAt: TimestampSchema.nullable(),
    lastErrorCode: z.string().nullable(),
});
export const QuickBooksConnectStartSchema = z.strictObject({
    authorizationUrl: z.url(),
});
export const QuickBooksConnectRequestSchema = z.strictObject({
    /** Where the browser lands in the web app after Intuit sends it back. */
    returnTo: z.string().max(1000).default('/settings/integrations'),
});
